import {Clock, ShieldCheck, Undo2, Wallet} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';

export const WHATS_A_HOLD_CARD_ID = 'whats-a-hold';
export const WHATS_AN_AUTHORISATION_CARD_ID = 'whats-an-authorisation';
export const DASHED_ISNT_A_CHARGE_CARD_ID = 'dashed-isnt-a-charge';

export const paymentsRules: VelaRule[] = [
  {
    id: 'payments/whats-a-hold',
    section: 'goodToKnow',
    scenes: [VelaScene.Payments],
    priority: 30,
    evaluate: (ctx, t) =>
      ctx.cart.hasHolds
        ? {
            id: WHATS_A_HOLD_CARD_ID,
            icon: <ShieldCheck />,
            title: t('card.whats_a_card_hold.title'),
            description: t('card.whats_a_card_hold.body'),
          }
        : null,
  },
  {
    id: 'payments/whats-an-authorisation',
    section: 'goodToKnow',
    scenes: [VelaScene.Payments],
    priority: 29,
    evaluate: (ctx, t) =>
      ctx.cart.hasAuthorisations
        ? {
            id: WHATS_AN_AUTHORISATION_CARD_ID,
            icon: <ShieldCheck />,
            title: t('card.whats_a_card_authorisation.title'),
            description: t('card.whats_a_card_authorisation.body'),
          }
        : null,
  },
  {
    id: 'payments/pay-later',
    section: 'goodToKnow',
    scenes: [VelaScene.Payments],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.cart.hasPayLater
        ? null
        : {
            id: 'pay-later',
            icon: <Wallet />,
            title: t('card.not_sure_about_an_extra.title'),
            description: t('card.not_sure_about_an_extra.body'),
          },
  },
  {
    id: 'payments/pay-later-send-back',
    section: 'aboutPayLater',
    scenes: [VelaScene.Payments],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.cart.hasPayLater
        ? {
            id: 'pay-later-send-back',
            icon: <Undo2 />,
            title: t('card.changed_your_mind_pay_later.title'),
            description: t('card.changed_your_mind_pay_later.body'),
          }
        : null,
  },
  {
    id: 'payments/pay-later-no-deadline',
    section: 'aboutPayLater',
    scenes: [VelaScene.Payments],
    priority: 10,
    evaluate: (ctx, t) =>
      ctx.cart.hasPayLater
        ? {
            id: 'pay-later-no-deadline',
            icon: <Clock />,
            title: t('card.no_deadline_pressure.title'),
            description: t('card.no_deadline_pressure.body'),
          }
        : null,
  },
  {
    id: 'order-history/hold-isnt-a-charge',
    section: 'readingYourHistory',
    scenes: [VelaScene.OrderHistory],
    priority: 30,
    evaluate: (ctx, t) =>
      ctx.cart.hasReceipts
        ? {
            id: DASHED_ISNT_A_CHARGE_CARD_ID,
            icon: <ShieldCheck />,
            title: t('card.hold_isnt_a_charge.title'),
            description: t('card.hold_isnt_a_charge.body'),
          }
        : null,
  },
  {
    id: 'order-history/refund-timing',
    section: 'readingYourHistory',
    scenes: [VelaScene.OrderHistory],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.cart.hasReceipts
        ? {
            id: 'refund-timing',
            icon: <Clock />,
            title: t('card.refund_timing.title'),
            description: t('card.refund_timing.body'),
          }
        : null,
  },
];
